export enum userType {
  Basic = 1,
  Email = 2,
  SSO = 3,
}
